import { useRef, type ChangeEvent } from 'react';
import { Button, Stack } from '@mui/material';
import FrontRoyalSpinner from 'FrontRoyalSpinner';

type Props = {
    uploading: boolean;
    accept?: string;
    onPick: (files: File[]) => void;
};

// Picks one or more files and hands them to the caller, which runs the upload. The resource lists
// upload straight away rather than waiting for the course to save, as they did in Angular.
export default function UploadFilesButton({ uploading, accept, onPick }: Props) {
    const inputRef = useRef<HTMLInputElement>(null);

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        const files = Array.from(event.target.files || []);

        // Clear the input so the same file can be picked twice in a row.
        event.target.value = '';

        if (files.length > 0) onPick(files);
    }

    return (
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Button
                name="uploader"
                variant="contained"
                color="primary"
                disabled={uploading}
                onClick={() => inputRef.current?.click()}
            >
                Upload
            </Button>

            {uploading && <FrontRoyalSpinner className="inline" />}

            <input
                ref={inputRef}
                type="file"
                multiple
                accept={accept}
                onChange={handleChange}
                style={{ display: 'none' }}
            />
        </Stack>
    );
}
